export const MAILER_MODEL = {
    institutionId: null,
    host: null,
    port: null,
    username: null,
    password: null,
}